import { UserAgentApplication } from 'msal';
import { AuthService } from './auth.service';
import { MsalAuthInstance } from './auth.instance';
import { AUTH_CONFIG, MsalConfiguration } from './auth.config';

export function provideAuth(configuration: MsalConfiguration) {
  return [
    {
      provide: AUTH_CONFIG,
      useValue: configuration,
    },
    {
      provide: MsalAuthInstance,
      useFactory: (msal: MsalConfiguration) => {
        return new UserAgentApplication(msal.config);
      },
      deps: [AUTH_CONFIG],
    },
    AuthService,
  ];
}
